import _ from 'underscore'
import Types from '../../../../actions/Types'

const initialState = {
  isFetching: false,
  id: null,
  data: null,
  error: null
}

export default (state = initialState, action = null) => {
  switch (action.type) {
    case Types.COMPARTMENTS.LIST.FETCH:
      return _.extend({}, state, {
        isFetching: true,
        id: action.id,
        error: null
      })
    case Types.COMPARTMENTS.LIST.SUCCESS:
      return _.extend({}, state, {
        isFetching: false,
        data: action.data,
        error: null
      })
    case Types.COMPARTMENTS.LIST.ERROR:
      return _.extend({}, state, {
        isFetching: false,
        data: null,
        error: action.error
      })
    case Types.APP.CLEARERROR:
      return _.extend({}, state, {
        error: null
      })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/root/entities/compartments/list.js